import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Header.scss';

const Header = () => {
    const location = useLocation();
    const isWorksPage = location.pathname === '/' || location.pathname === '/works';
    const isShowsPage = location.pathname === '/shows';
    const isMessagesPage = location.pathname === '/messages';

    return (
        <header>

            <p className="header-logo"><Link to="/works">nthng</Link></p>

            {/* Navigation menu */}
            <ul className='header-list'>
                <li>
                    {isWorksPage ? (
                        <span className="active-link">works</span>
                    ) : (
                        <Link to="/works">works</Link>
                    )}
                </li>
                <li>
                    {isShowsPage ? (
                        <span className="active-link">shows</span>
                    ) : (
                        <Link to="/shows">shows</Link>
                    )}
                </li>
                <li>
                    {isMessagesPage ? (
                        <span className="active-link">msg</span>
                    ) : (
                        <Link to="/messages">msg</Link>
                    )}
                </li>
            </ul>
        </header>
    );
};

export default Header;